import RefreshmentApprovalTypes from './RefreshmentApproval.types';

export const refreshmentApprovalStart = (data: any) => ({
	type: RefreshmentApprovalTypes.REFRESHMENT_APPROVAL_START,
	payload: data,
});

export const refreshmentApprovalSuccess = (data: any) => ({
	type: RefreshmentApprovalTypes.REFRESHMENT_APPROVAL_SUCCESS,
	payload: data,
}); 

export const refreshmentApprovalFailure = (data: any) => ({
	type: RefreshmentApprovalTypes.REFRESHMENT_APPROVAL_FAILURE,
	payload: data,
});

export const calculateRefreshmentStart = (data: any) => ({
	type: RefreshmentApprovalTypes.CALCULATE_REFRESHMENT_START,
	payload: data,
});

export const calculateRefreshmentSuccess = (data: any) => ({
	type: RefreshmentApprovalTypes.CALCULATE_REFRESHMENT_SUCCESS,
	payload: data,
});

export const calculateRefreshmentFailure = (data: any) => ({
	type: RefreshmentApprovalTypes.CALCULATE_REFRESHMENT_FAILURE,
	payload: data,
});

export const approveRefreshmentStart = (data: any) => ({
	type: RefreshmentApprovalTypes.APPROVE_REFRESHMENT_START,
	payload: data,
});

export const approveRefreshmentSuccess = (data: any) => ({
	type: RefreshmentApprovalTypes.APPROVE_REFRESHMENT_SUCCESS,
	payload: data,
});

export const approveRefreshmentFailure = (data: any) => ({
	type: RefreshmentApprovalTypes.APPROVE_REFRESHMENT_FAILURE,
	payload: data,
});

export const bulkApproveRefreshmentStart = (data: any) => ({
	type: RefreshmentApprovalTypes.BULK_APPROVE_REFRESHMENT_START,
	payload: data,
});

export const bulkApproveRefreshmentSuccess = (data: any) => ({
	type: RefreshmentApprovalTypes.BULK_APPROVE_REFRESHMENT_SUCCESS,
	payload: data,
});

export const bulkApproveRefreshmentFailure = (data: any) => ({
	type: RefreshmentApprovalTypes.BULK_APPROVE_REFRESHMENT_FAILURE,
	payload: data,
});

export const rejectRefreshmentStart = (data: any) => ({
	type: RefreshmentApprovalTypes.REJECT_REFRESHMENT_START,
	payload: data,
});

export const rejectRefreshmentSuccess = (data: any) => ({
	type: RefreshmentApprovalTypes.REJECT_REFRESHMENT_SUCCESS,
	payload: data,
});

export const rejectRefreshmentFailure = (data: any) => ({
	type: RefreshmentApprovalTypes.REJECT_REFRESHMENT_FAILURE,
	payload: data,
}); 